import { morph } from '@theme/morph';

class QuickFilters extends HTMLElement {
    constructor() {
        super();
        this.filters = this.querySelectorAll('details');
        this.facetFilters = document.querySelector('facet-filters');
        this.form = this.facetFilters.querySelector('form');
    }

    connectedCallback() {
        this.addListeners();
    }

    disconnectedCallback() {
        document.removeEventListener('click', this.handleFilterClick.bind(this));
        this.removeEventListener('change', this.handleFilterChange.bind(this));
        document.removeEventListener('on:facet-filters:updated', this.handleFacetFiltersUpdated.bind(this));
    }

    addListeners() {
        document.addEventListener('click', (event) => {
            const details = this.querySelectorAll('.filter-details-group[open]');

            details.forEach((detail) => {
                if (!detail.contains(event.target)) {
                    detail.removeAttribute('open');
                }
            });
        });

        this.addEventListener('change', this.handleFilterChange.bind(this));
        document.addEventListener('on:facet-filters:updated', this.handleFacetFiltersUpdated.bind(this));
    }

    handleFacetFiltersUpdated(event) {
        if (event.detail.newSectionHtml.querySelector('quick-filters')) {            
            morph(this, event.detail.newSectionHtml.querySelector('quick-filters'));
            this.addListeners();
        }
    }

    handleFilterClick(event) {
        this.filters.forEach((filter) => {
            filter.open = false;
        });
        event.target.closest('details').open = true;
    }

    handleFilterChange(event) {
        const facetInput = this.facetFilters.querySelector(
            `input[name="${event.target.name}"][value="${event.target.value}"]`
        );

        if (facetInput) {
            facetInput.checked = event.target.checked;
            facetInput.dispatchEvent(
                new Event("input", { bubbles: true }),
            );
        }
    }

}

if (!customElements.get('quick-filters')) {
    customElements.define('quick-filters', QuickFilters);
}
